module.exports = __webpack_public_path__ + "static/media/21-10.7aca63ee.mp3";